import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const LocacoesTableScroll = styled.div`
  position: relative;
  overflow-x: hidden;
  min-height: ${props => (props.loading ? '200px' : 'auto')};

  table {
    width: 100%;
    min-width: 0;
    border-collapse: collapse;
    table-layout: fixed;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
`;

export const LocacoesTableEl = styled.table`
  margin: 0;
`;

export const LocacoesLoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.78);
  backdrop-filter: blur(2px);
`;

export const LocacoesSpinner = styled.span`
  display: block;
  width: 38px;
  height: 38px;
  border: 3px solid rgba(21, 43, 78, 0.1);
  border-top-color: #ff7200;
  border-radius: 50%;
  animation: ${spin} 0.75s linear infinite;
`;

export const LocacoesEmptyRow = styled.tr``;

export const LocacoesEmptyCell = styled.td`
  text-align: center;
  padding: 2.5rem 1rem !important;
  color: #8b95a5;
  font-size: 0.875rem;
`;
